export default function getPageHttpCode ()
{
	const meta = document.querySelector('meta[http-equiv="x-page-status-code"]');

	if (!meta) return undefined;

	const code = parseInt(meta.getAttribute('content'));

	return isNaN(code) ? undefined : code;
}